import {useEffect, useRef, useCallback} from 'react';
import gsap from "gsap";
import {useDispatch, useSelector} from "react-redux";
import {defaultOrder} from "../redux/PanelsReducer";

const PanelAnimations = (props) => {

    const animationDuration = 1500;
    const panelData = useSelector(state => state.panelData);
    const accessible = useSelector(state => state.accessible);
    const dispatch = useDispatch()
    const prevStackOrder = useRef({});


    function getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
    }

    const forceHide = useCallback(()=>{
        gsap.to(props.fixedStage.current, {display: 'none', duration: 0});
    }, [props])

    const forceShow = useCallback(()=>{

        let extraBackGround = props.extraBackGround ? props.extraBackGround.current : null;
        let midGround = props.midGround ? props.midGround.current : null;
        let bonusGround = props.bonusGround ? props.bonusGround.current : null;

        gsap.to(props.fixedStage.current, {display: 'flex', duration: 0});
        if (props.backGround && props.backGround.current) gsap.to(props.backGround.current,
            {opacity: 1, transform: `perspective(100px) translateZ(0px) scale(1.25)`, duration: 0});
        if (extraBackGround) gsap.to(extraBackGround,
            {opacity: 1, transform: `perspective(100px) translateZ(0px)`, duration: 0});
        if (midGround) gsap.to(midGround,
            {opacity: 1, transform: `perspective(100px) translateZ(0px)`, duration: 0});
        if (bonusGround) gsap.to(bonusGround,
            {opacity: 1,transform: `perspective(100px) translateZ(0px)`, duration: 0});
        gsap.to(props.foreGround.current,
            {opacity: 1, transform: `perspective(100px) translateZ(0px) translateY(0px)`, duration: 0})

        let originalBy = props.foreGround.current.querySelector('.signature');
        let explore = props.foreGround.current.querySelector('.explore');
        if(explore) gsap.to(explore,
            { transform: `perspective(100px) translateZ(0px) translateY(0px)`, opacity: 1, duration: 0});
        if(originalBy) {
            originalBy.style.backgroundPosition = 'center top';
            gsap.to(originalBy,
                {transform: `perspective(100px) translateZ(0px) translateY(0px)`, opacity: 1, duration: 0});
        }

    }, [props])

    const buildAnimations = useCallback((direction)=>{

        let duration = animationDuration / 1000;
        let shift = props.shift ? props.shift : 80;

        let fixedStage = props.fixedStage.current;
        let backGround = props.backGround.current;
        let foreGround = props.foreGround.current;
        let extraBackGround = props.extraBackGround ? props.extraBackGround.current : null;
        let midGround = props.midGround ? props.midGround.current : null;
        let bonusGround = props.bonusGround ? props.bonusGround.current : null;

        let originalBy = foreGround.querySelector('.signature');
        let explore = foreGround.querySelector('.explore');

        if(direction === 'onEnter'){

            dispatch({ type: "INCREASE_ANIMATION_COUNT"});

            /** turn on content **/


            /** fade in, zoom in background 1 -> 1.25 **/
            /** fade in, zoom in mid range  .6 -> 1 **/
            /** fade in, zoom in squares  .5 -> 1 (slower) **/

            gsap.to(fixedStage, {
                delay: duration * .6,
                display: 'flex',
                duration: 0,
                onComplete: ()=>{

                    gsap.fromTo(backGround,
                        {opacity: 0, transform: `perspective(100px) translateZ(-100px) scale(2)`},
                        {opacity: 1, transform: `perspective(100px) translateZ(0px) scale(1.25)`,
                            delay: 0.2, duration: duration*1.5, onComplete:()=>{
                                dispatch({ type: "DECREASE_ANIMATION_COUNT"});
                            }
                        });

                    if(extraBackGround) gsap.fromTo(extraBackGround,
                        {opacity: 0, transform: `perspective(100px) translateZ(-100px)`},
                        {opacity: 1, transform: `perspective(100px) translateZ(0px)`, delay: 0.1, duration: duration*1.5 });
                    if(midGround) gsap.fromTo(midGround,
                        {opacity: 0, transform: `perspective(100px) translateZ(-100px)`},
                        {opacity: 1, transform: `perspective(100px) translateZ(0px)`, delay: 0.1, duration: duration*1.5 });
                    if(bonusGround) gsap.fromTo(bonusGround,
                        {opacity: 0, transform: `perspective(100px) translateZ(-100px)`},
                        {opacity: 1, transform: `perspective(100px) translateZ(0px)`, delay: 0.1, duration: duration*1.5 });

                    /** explore and original are more or less resets here **/
                    if(explore) gsap.fromTo(explore,
                        {transform: `perspective(100px) translateZ(0px) translateY(0px)`, opacity: 0},
                        {transform: `perspective(100px) translateZ(0px) translateY(0px)`, opacity: 1, duration: duration*1.5});

                    if(originalBy) {
                        originalBy.style.backgroundPosition = 'center top';
                        gsap.fromTo(originalBy,
                            {transform: `perspective(100px) translateZ(0px) translateY(0px)`, },
                            {transform: `perspective(100px) translateZ(0px) translateY(0px)`, duration: duration*1.5});
                    }

                    gsap.fromTo(foreGround,
                        {transform: `perspective(100px) translateZ(-100px)`},
                        {transform: `perspective(100px) translateZ(0px)`, duration: duration*1.5, });

                    gsap.fromTo(foreGround,
                        {opacity: 0},
                        {opacity: 1, duration: duration/2, });

                }
            })


        }

        if(direction === 'onLeave'){

            dispatch({ type: "INCREASE_ANIMATION_COUNT"});

            /** fade out, zoom in background 1.25 -> 1.5 **/
            /** fade out, zoom in mid range  1 -> 3 **/
            /** fade out, zoom in squares  1 -> 6 (slower) **/

            /** turn off content **/


            gsap.fromTo(backGround, {opacity: 1, scale: 1.25},{opacity: 0, scale: 2, delay: 0.4, duration: duration });

            if(extraBackGround) gsap.fromTo(extraBackGround,
                {opacity: 1, transform: `perspective(100px) translateZ(0px)`},
                {opacity: 0, transform: `perspective(100px) translateZ(200px)`, delay: 0.3, duration: duration*1.5});

            if(midGround) gsap.fromTo(midGround,
                {opacity: 1, transform: `perspective(100px) translateZ(0px)`},
                {opacity: 0, transform: `perspective(100px) translateZ(200px)`, delay: 0.3, duration: duration*1.5 });
            if(bonusGround) gsap.fromTo(bonusGround,
                {opacity: 1, transform: `perspective(100px) translateZ(0px)`},
                {opacity: 0, transform: `perspective(100px) translateZ(200px)`, delay: 0.3, duration: duration*1.5 });

            if(explore) {
                gsap.fromTo(explore,
                    {transform: `perspective(100px) translateZ(0px) translateY(0px)`},
                    {transform: `perspective(100px) translateZ(200px) translateY(600px)`,duration: duration*1.5});
                gsap.fromTo(explore, {opacity: 1}, {opacity:0, duration: duration});
            }
            if(originalBy) gsap.fromTo(originalBy,
                {transform: `perspective(100px) translateZ(0px) translateY(0px)`},
                {transform: `perspective(100px) translateZ(200px) translateY(300px)`, delay: 0.1, duration: duration*1.5});

            gsap.fromTo(foreGround,
                {transform: `perspective(100px) translateZ(0px) translateY(0px)`},
                { transform: `perspective(100px) translateZ(200px)  translateY(${shift}px)`, delay: 0.2, duration: duration*1.25, onComplete: ()=>{
                        gsap.to(fixedStage, { display: 'none', duration: 0 });
                    }});


            // reset after longest animation + delay, altered based on conditional layers
            let timeout =  duration*1.5 + 0.1;
            if(extraBackGround || midGround || bonusGround) timeout = duration*1.5 + 0.3
            setTimeout(()=>{ dispatch({ type: "DECREASE_ANIMATION_COUNT"}); }, timeout);

        }

        if(direction === 'onEnterBack'){

            /** turn on content **/

            dispatch({ type: "INCREASE_ANIMATION_COUNT"});

            /** fade in, zoom out background 1.5 -> 1.25 **/
            /** fade in, zoom out mid range  3 -> 1 **/
            /** fade in, zoom out squares  6 -> 1 (slower) **/

            gsap.to(fixedStage, {
                delay: duration/2,
                display: 'flex',
                duration: 0,
                onComplete: ()=>{

                    gsap.to(backGround, 0,{transform:'perspective(100px) translateZ(0px)', onComplete:()=>{
                            gsap.fromTo(backGround, {opacity: 0, scale: 2}, { opacity: 1, scale: 1.25, duration: duration });
                        }})


                    if(extraBackGround) gsap.fromTo(extraBackGround,
                        {opacity: 0, transform: `perspective(100px) translateZ(200px)`},
                        {opacity: 1, transform: `perspective(100px) translateZ(0px)`, delay: 0.1, duration: duration });
                    if(midGround) gsap.fromTo(midGround,
                        {opacity: 0, transform: `perspective(100px) translateZ(200px)`},
                        {opacity: 1, transform: `perspective(100px) translateZ(0px)`, delay: 0.1, duration: duration });
                    if(bonusGround) gsap.fromTo(bonusGround,
                        {opacity: 0, transform: `perspective(100px) translateZ(200px)`},
                        {opacity: 1, transform: `perspective(100px) translateZ(0px)`, delay: 0.1, duration: duration });

                    if(explore) {

                        gsap.fromTo(explore,
                            {transform: `perspective(100px) translateZ(200px) translateY(600px)`},
                            {transform: `perspective(100px) translateZ(0px) translateY(0px)`, duration: duration});

                        gsap.fromTo(explore,
                            {opacity: 0},
                            {opacity: 1, duration: 0});
                    }
                    if(originalBy) {
                        originalBy.style.backgroundPosition = 'center top';
                        gsap.fromTo(originalBy,
                            {transform: `perspective(100px) translateZ(200px) translateY(300px)`},
                            {transform: `perspective(100px) translateZ(0px) translateY(0px)`, duration: duration});
                    }

                    gsap.fromTo(foreGround,
                        {opacity: 0},
                        {opacity: 1, delay: 0.2, duration: duration});
                    gsap.fromTo(foreGround,
                        {transform: `perspective(100px) translateZ(200px)  translateY(${shift}px)`},
                        {transform: `perspective(100px) translateZ(0px) translateY(0px)`,
                                    delay: 0.2, duration: duration, onComplete:()=>{
                                        dispatch({ type: "DECREASE_ANIMATION_COUNT"});
                                    }});
                }
            })

        }

        if(direction === 'onLeaveBack'){

            dispatch({ type: "INCREASE_ANIMATION_COUNT"});

            /** fade out, zoom out background 1.25 -> 1 **/
            /** fade out, zoom out mid range  1 -> .6 **/
            /** fade out, zoom out squares  1 -> .5 (slower) **/

            /** turn off content **/

            gsap.fromTo(backGround,
                {opacity: 1, transform: `perspective(100px) translateZ(0px) scale(1.25)`},
                {opacity: 0, transform: `perspective(100px) translateZ(-100px) scale(2)`, duration: duration});

            if(extraBackGround) gsap.fromTo(extraBackGround,
                {opacity: 1, transform: `perspective(100px) translateZ(0px)`},
                {opacity: 0, transform: `perspective(100px) translateZ(-100px)`, delay: 0.1, duration: duration });
            if(midGround) gsap.fromTo(midGround,
                {opacity: 1, transform: `perspective(100px) translateZ(0px)`},
                {opacity: 0, transform: `perspective(100px) translateZ(-100px)`, delay: 0.1, duration: duration });
            if(bonusGround) gsap.fromTo(bonusGround,
                {opacity: 1, transform: `perspective(100px) translateZ(0px)`},
                {opacity: 0, transform: `perspective(100px) translateZ(-100px)`, delay: 0.1, duration: duration });

            /** explore and original are more or less resets here **/
            if(explore) gsap.fromTo(explore,
                {transform: `perspective(100px) translateZ(0px) translateY(0px)`},
                {transform: `perspective(100px) translateZ(0px) translateY(0px)`, duration: duration});
            if(originalBy) gsap.fromTo(originalBy,
                {transform: `perspective(100px) translateZ(0px) translateY(0px)`},
                {transform: `perspective(100px) translateZ(0px) translateY(0px)`, duration: duration});

            gsap.fromTo(foreGround,
                {opacity: 1, transform: `perspective(100px) translateZ(0px)`},
                { opacity: 0, transform: `perspective(100px) translateZ(-100px)`,
                            delay: 0.2, duration: duration, onComplete: ()=>{
                                gsap.to(fixedStage, { display: 'none', duration: 0 });
                                dispatch({ type: "DECREASE_ANIMATION_COUNT"});
                            }});


        }


    },[props, dispatch]);



    const  checkDirection = useCallback((from,to)=>{

        let here, there;
        Object.keys(defaultOrder).forEach((key, index)=>{
            if(key === from) here = index;
            if(key === to) there = index;
        });

        let scrollDir = here > there ? 'up': 'down';

        let direction;
        if(scrollDir === 'up'){
            direction = props.panel === to ? 'onEnterBack' : 'onLeaveBack';
        } else {
            direction = props.panel === to ? 'onEnter' : 'onLeave';
        }

        return direction;

    }, [props.panel]);


    useEffect(()=>{

        if(accessible.siteEntered){


            let from = getKeyByValue(prevStackOrder.current, 'active'); // get "from" from where you were, not the analyzed "prev"
            let prevNext = getKeyByValue(prevStackOrder.current, 'next'); // get "from" from where you were, not the analyzed "prev"
            let to = getKeyByValue(panelData.stackOrder, 'active');
            let next = getKeyByValue(panelData.stackOrder, 'next');

            /** static next panel autoshow macro exit from bottom, Only Macro's use Top Exit and only Macro's should force the layer beneath visible **/
            if(accessible.exploring && accessible.topExit && props.panel === next && props.panel === prevNext && from === to){
                console.log('Force Show')
                forceShow()
            }

            /** TODO SCROLL UP ON TOP EXIT NOT COMING IN HERE!!! **/
            if(!accessible.exploring && accessible.topExit){
                if(props.panel === next && props.panel === prevNext && from === to){
                    forceHide();
                }
            }

            /** only animate from and to panels **/
            if(from !== to && (props.panel === from || props.panel === to || props.panel === next)) {

                let direction = checkDirection(from,to);
                let skipAnimation = panelData.skipAnimation || props.skipAnimation;

                /** natural flow and clicks **/
                if(!skipAnimation && !accessible.exploring){

                    // console.log('ANIMATING FROM: ',from, ' TO: ',to)
                    setTimeout(()=>{
                        buildAnimations(direction);
                    },0); // MicroInfluencers are somehow delayed for fixedStage, backGround and foreGround... it is the only one, thus the timeout.
                }


                /** force hide a panel **/
                if(skipAnimation && props.panel === from){
                    forceHide()
                }
            }

            if(accessible.topExit){
                dispatch({ type: "SET_ACCESSIBLE",
                    payload: {
                        ...accessible,
                        topExit: false
                    }
                });
            }

            prevStackOrder.current = panelData.stackOrder;

        }



    },[accessible, panelData, checkDirection, buildAnimations, forceHide, forceShow, props.panel,
        props.skipAnimation, dispatch])



    return <></>
};

export default PanelAnimations
